import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateTimePicker } from "@mui/x-date-pickers";
import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import ModalItemRota from "components/modal/transportes/ModalItemRota";
import ModalItensRotaVisualizar from "components/modal/transportes/ModalItensRotaVisualizar";
import ModalSelecionarColeta from "components/modal/transportes/ModalSelecionarColeta";
import ModalSelecionarMdfe from "components/modal/transportes/ModalSelecionarMdfe";
import dayjs from "dayjs";
import Usuario from "model/administracao/cadastro/Usuario";
import Veiculo from "model/gestao/frotas/Veiculo";
import Endereco from "model/transportes/endereco/Endereco";
import Mdfe from "model/transportes/mdfe/Mdfe";
import ItemRota from "model/transportes/rota/ItemRota";
import Rota from "model/transportes/rota/Rota";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { geocode, OutputFormat, RequestType, setDefaults } from "react-geocode";
import "react-hook-form";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import RotaService from "service/transportes/RotaService";
import { converterDataHora } from "utils/convert";
import { generateKey } from "utils/generateKey";

const rotaService = new RotaService();

export default function RotaCadastro() {
    const keyMaps = 'AIzaSyDQbLYImEY_K1U92ocx6-e46qC2AjskIfo';
    const [queryParameters] = useSearchParams();

    const [modalMdfeVisible, setModalMdfeVisible] = useState(false);
    const [modalSelecionarColetaVisible, setModalSelecionarColetaVisible] = useState(false);
    const [modalItemRotaVisualizar, setModalItemRotaVisualizar] = useState({ visible: false, itemIndex: 0 });

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const [rota, setRota] = useState<Rota>(new Rota());
    const [titulo, setTitulo] = useState<string>('Rota');

    const [motoristas, setMotoristas] = useState<Usuario[]>([]);
    const [veiculos, setVeiculos] = useState<Veiculo[]>([]);

    const [modalItemRota, setModalItemRota] = useState({ visible: false, data: null });

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    useEffect(() => {
        rotaService.motoristas().then((data) => {
            setMotoristas(data);
        }).catch(err => {
            console.log(err);
        });

        rotaService.veiculos().then((data) => {
            setVeiculos(data);
        }).catch(err => {
            console.log(err);
        });
        setDefaults({
            key: keyMaps,
            language: "pt",
            region: "br",
            outputFormat: OutputFormat.JSON
        });
    }, []);

    function validar() {

        if (!rota.nome) {
            setError("nome", { type: "manual", message: "Nome é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    const headerTable = <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
        <div></div>
        <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Itens da rota</span>
        <div >
            <Button
                style={{ marginRight: '8px' }}
                type="button" icon={<FontAwesomeIcon icon="add" />}
                label="Adicionar MDF-e na rota"
                onClick={() => setModalMdfeVisible(true)}
            />
            <Button icon={<FontAwesomeIcon icon="add" />}
                label={"Adicionar coleta"}
                onClick={() => setModalSelecionarColetaVisible(true)}
            />
        </div>
    </div>

    return (

        <BaseCadastro model={rota} service={rotaService} setModel={(value: Rota) => setRota(value)} validar={() => validar()} urlService="/rota" pathCadastro="/rota" tituloPagina={titulo}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            {modalMdfeVisible ? <ModalSelecionarMdfe visible={modalMdfeVisible} onHide={() => { setModalMdfeVisible(false) }} onConfirm={(mdfe: Mdfe) => {
                mdfe.listMdfeCte.forEach((mdfeCte) => {
                    let item = new ItemRota();
                    item.tipo = "ENTREGA";
                    item.sequencial = rota.itens.length + 1;
                    item.mdfeCte = mdfeCte;
                    item.observacao = mdfeCte.cte?.dadosComplementares?.xobs || "";
                    item.key = generateKey();

                    const endereco: Endereco = new Endereco();
                    endereco.bairro = mdfeCte.cte?.destinatario?.enderDest.xBairro || "";
                    endereco.cep = mdfeCte.cte?.destinatario?.enderDest.cep || "";
                    endereco.cidade = mdfeCte.cte?.destinatario?.enderDest.xMun || "";
                    endereco.estado = mdfeCte.cte?.destinatario?.enderDest.uf || "";
                    endereco.logradouro = mdfeCte.cte?.destinatario?.enderDest.xLgr || "";
                    endereco.numero = mdfeCte.cte?.destinatario?.enderDest.nro || 0;
                    endereco.complemento = mdfeCte.cte?.destinatario?.enderDest.xcpl || "";

                    let descEndereco = `${endereco.logradouro}, ${endereco.numero} - ${endereco.bairro} - ${endereco.cidade} - ${endereco.estado}`;

                    geocode(RequestType.ADDRESS, descEndereco)
                        .then(({ results }) => {
                            if (results.length > 0) {
                                const { geometry } = results[0];
                                endereco.latitude = geometry.location.lat;
                                endereco.longitude = geometry.location.lng;
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                        });

                    item.endereco = endereco;
                    rota.itens.push(item);
                });
                setRota({ ...rota });
                setModalMdfeVisible(false);
            }} /> : null}
            {modalSelecionarColetaVisible && <ModalSelecionarColeta
                visible={modalSelecionarColetaVisible} onHide={() => setModalSelecionarColetaVisible(false)}
                onConfirm={(coleta) => {
                    let item = new ItemRota();
                    item.tipo = "COLETA";
                    item.sequencial = rota.itens.length + 1;
                    item.coleta = coleta;
                    item.dataPrevista = coleta.dataPrevista;
                    item.key = generateKey();
                    item.endereco = coleta.endereco;
                    rota.itens.push(item);
                    setRota({ ...rota });
                    setModalSelecionarColetaVisible(false)
                }}
            />}

            {modalItemRota.visible ? <ModalItemRota value={modalItemRota.data}
                visible={modalItemRota.visible} onHide={() => setModalItemRota({ visible: false, data: null })}
                onConfirm={(value) => {
                    let itens = [...rota.itens];
                    if (value.key) {
                        let index = itens.findIndex((item) => item.key === value.key);
                        itens[index] = value;
                    } else {
                        value.key = generateKey();
                        itens.push(value);
                    }
                    setRota({ ...rota, itens: itens });
                    setModalItemRota({ visible: false, data: null });
                }} /> : null}
            {modalItemRotaVisualizar.visible ? <ModalItensRotaVisualizar
                visible={modalItemRotaVisualizar.visible} onHide={() => setModalItemRotaVisualizar({ visible: false, itemIndex: 0 })}
                itemIndex={modalItemRotaVisualizar.itemIndex} itens={rota.itens}
            /> : null}
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText
                        className={errors.nome ? "p-invalid" : ""}
                        required value={rota.nome}
                        style={{ width: '300px' }}
                        {...register("nome", {
                            onChange: (e) => {
                                setRota({ ...rota, nome: e.target.value })
                                clearErrors("nome")
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Data Prevista de Início</Label>
                <div className="col-sm-12">
                    <DateTimePicker
                        sx={{ width: '300px' }}
                        value={dayjs(rota.dataPrevistaInicio)}
                        ampm={false}
                        format={"DD/MM/YYYY HH:mm"}
                        onChange={value => {
                            setRota({ ...rota, dataPrevistaInicio: value?.toDate() || null })
                        }}
                    />
                </div>
                {errors.dataPrevistaInicio && errors.dataPrevistaInicio.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.dataPrevistaInicio?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Motorista</Label>
                <div className="col-sm-12">
                    <Dropdown
                        style={{ width: '300px' }}
                        options={motoristas}
                        optionLabel="nome"
                        dataKey="id"
                        value={rota.motorista}
                        onChange={(e) => {
                            setRota({ ...rota, motorista: e.value })
                        }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Veículo</Label>
                <div className="col-sm-12">
                    <Dropdown
                        style={{ width: '300px' }}
                        options={veiculos}
                        optionLabel="modelo"
                        dataKey="id"
                        value={rota.veiculo}
                        onChange={(e) => {
                            setRota({ ...rota, veiculo: e.value })
                        }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Status</Label>
                <div className="col-sm-12">
                    <InputText
                        disabled
                        className="col-sm-12" style={{ width: '300px' }}
                        value={rotaService.getStatusLabel(rota.status)}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <DataTable
                        header={headerTable}
                        dataKey="key"
                        value={rota ? rota.itens : []}
                        scrollHeight="500px"
                        scrollable={true}
                        reorderableRows
                        onRowReorder={(e) => {
                            let rotaLocal = { ...rota };
                            let itens = e.value.map((item, index) => {
                                return {
                                    ...item,
                                    sequencial: index + 1,
                                }
                            })
                            rotaLocal.itens = itens as ItemRota[];

                            setRota(rotaLocal);
                        }}
                        emptyMessage="Nenhum registro encontrado"
                    >
                        <Column rowReorder style={{ width: '3%' }}></Column>
                        {rota.itens.findIndex((item) => item && item.endereco && !item.endereco.latitude) > -1 ?
                            <Column body={(rowData) => !rowData.endereco.latitude ? <FontAwesomeIcon icon="exclamation-circle" color="#EEAD2D" /> : null} style={{ width: 30, textAlign: "center" }} />
                            : null}
                        <Column field="tipo" header="Tipo" style={{ width: '10%' }} body={(rowData) => rotaService.getTipoItemLabel(rowData.tipo)}></Column>
                        <Column field="status" header="Status" style={{ width: '10%' }} body={(rowData) => rotaService.getStatusItemLabel(rowData.status)}></Column>
                        <Column header="Data Prevista" style={{ width: '10%' }} body={(rowData) => converterDataHora(rowData.dataPrevista)}></Column>
                        <Column field="dataRealizada" header="Data Realizada" style={{ width: '10%' }} body={(rowData) => converterDataHora(rowData.dataRealizada)}></Column>
                        <Column field="endereco.estado" header="Estado" style={{ width: '10%' }}></Column>
                        <Column field="endereco.cidade" header="Cidade" style={{ width: '10%' }}></Column>
                        <Column field="endereco.logradouro" header="Logradouro" style={{ width: '10%' }}></Column>
                        <Column field="endereco.numero" header="Número" style={{ width: '10%' }}></Column>
                        <Column body={(rowData, options) => <div style={{ width: "120px" }}>
                            <Button icon={<FontAwesomeIcon icon="edit" />} style={{ marginRight: 8 }} onClick={() => {
                                setModalItemRota({ visible: true, data: rowData });
                            }} />
                            <Button icon={<FontAwesomeIcon icon="eye" />} style={{ marginRight: 8 }} onClick={() => {
                                setModalItemRotaVisualizar({ visible: true, itemIndex: options.rowIndex });
                            }} />
                            <Button icon={<FontAwesomeIcon icon="trash" />} onClick={() => {
                                let itens = rota.itens.filter((item) => item.key !== rowData.key);
                                setRota({ ...rota, itens: itens });
                            }} />

                        </div>} style={{ whiteSpace: 'nowrap', width: '120px', maxWidth: "120px" }} bodyStyle={{ whiteSpace: 'nowrap', width: '120px', maxWidth: "120px" }}></Column>
                    </DataTable>
                </div>
            </div>

        </BaseCadastro>
    )
}
